// extracted by mini-css-extract-plugin
export default {"main":"MainContentWrapper_main__ZDhHl","mobileMenuIsOpened":"MainContentWrapper_mobileMenuIsOpened__pt5Vj"};